import { z } from 'zod';
export const PaginationSchema = z.object({
    // Query strings arrive as text ("2"); coerce so ?page=&limit= validate.
    page: z.coerce.number().int().positive().default(1),
    limit: z.coerce.number().int().positive().max(100).default(20),
});
export const PaginatedResponseSchema = (itemSchema) => z.object({
    items: z.array(itemSchema),
    total: z.number().int().nonnegative(),
    page: z.number().int().positive(),
    limit: z.number().int().positive(),
    totalPages: z.number().int().nonnegative(),
    hasNext: z.boolean(),
    hasPrev: z.boolean(),
});
